export const baseURL = process.env.REACT_APP_API_URL;

type GAuthResp = {
  success: boolean,
  userId?: string,
  token?: string,
  errorType: 'invalidIdentityDomain' | 'invalidToken' | 'unknown',
};

export const gauthAsync = async (idToken: string): Promise<GAuthResp> => {
  const resp = await fetch(`https://gauth2-wfoxr6wg7q-uc.a.run.app/?token=${idToken}`);
  if (resp.status >= 200 && resp.status < 300) {
    const r = await resp.json() as GAuthResp;
    return r;
  }
  const text = await resp.text();

  // tslint:disable-next-line:no-console
  console.error(new Error(`status: ${resp.status}, body: ${text}`));

  return {
    success: false,
    errorType: 'unknown',
  };
};


// WEBPACK FOOTER //
// ./src/api.ts